'use client'

import { Row } from '@christiankaindl/lyts'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import Button from '@shared/components/Button/Button'
import { SEARCH_RESULTS_LIST_ID } from '@shared/components/Law/SearchResultsList'
import { useSearch, useSearchResults } from './SearchProvider'

export default function Pagination() {
  const results = useSearchResults()
  const setPage = useSearch((state) => state.setPage)

  const currentPage = results?.page ?? 1
  const nbPages = Math.ceil((results?.found ?? 0) / 40)
  const isFirstPage = currentPage === 1
  const isLastPage = currentPage === nbPages

  if (!results || nbPages <= 1) {
    return null
  }

  const pages = getPagination(currentPage, nbPages)

  function handleClick(num: number) {
    setPage(num)
    // Results are swapped in place, so nothing resets the scroll position for us
    const list = document.getElementById(SEARCH_RESULTS_LIST_ID)
    if (list) {
      list.scrollIntoView()
    } else {
      window.scrollTo({ top: 0 })
    }
  }

  // function getHref (index: number): UrlObject {
  //   return {
  //     query: {
  //       ...searchParams && Object.fromEntries(searchParams?.entries()),
  //       p: String(index),
  //     },
  //   }
  // }

  return (
    <Row xAlign='center'>
      <Button
        circular
        square
        disabled={isFirstPage}
        onClick={() => {
          handleClick(currentPage - 1)
        }}
        // href={getHref(currentPage)}
      >
        <ChevronLeft size={20} />
      </Button>
      <Row gap='1px'>
        {pages.map((num, index) => {
          if (typeof num === 'string') {
            return <span key={`${index}-three-dots`}>{num}</span>
          }
          const isSelectedPage = num === currentPage
          return (
            <Button
              key={num}
              circular
              square
              size='small'
              variant={isSelectedPage ? 'raised' : 'flat'}
              // href={getHref(num + 1)}
              // linkProps={{ shallow: true }}
              onClick={() => {
                handleClick(num)
              }}
            >
              {num}
            </Button>
          )
        })}
      </Row>
      <Button
        circular
        square
        disabled={isLastPage}
        onClick={() => {
          handleClick(currentPage + 1)
        }}
        // href={getHref(currentPage + 2)}
      >
        <ChevronRight size={20} />
      </Button>
    </Row>
  )
}

function getPagination(currentPage: number, maxPages: number) {
  const delta = 2
  const range: number[] = []

  range.push(1)
  for (let i = currentPage - delta; i <= currentPage + delta; i++) {
    if (i > 1 && i < maxPages) {
      range.push(i)
    }
  }
  range.push(maxPages)

  return range
    .map((i) => {
      const l = range[range.indexOf(i) - 1]
      if (!l) return i

      if (i - l === delta) {
        return [l + 1, i]
      } else if (i - l !== 1) {
        return ['…', i] as const
      }

      return i
    })
    .flat()
}
